import { FETCH_MULTI_CURRENCY_SUCCEEDED, FETCH_MULTI_CURRENCY_STARTED } from './ActionTypes';
import { fetchCurrencyInfo } from '../api/multiCurrencyApi';
export function fetchCurrencyInfoAction() {
  return dispatch => {
    dispatch({
      type: FETCH_MULTI_CURRENCY_STARTED
    });
    return fetchCurrencyInfo().then(data => {
      dispatch({
        type: FETCH_MULTI_CURRENCY_SUCCEEDED,
        payload: data
      });
    });
  };
}